import { Helmet } from "react-helmet-async"
import { HotelOtaBooking } from "../../../HotelOtaBookings"
import { useParams } from "../../../router-utils"

export default function OtaBookingDetailPage() {
	const { bookingId } = useParams("/ota-bookings/:bookingId")

	return (
		<>
			<Helmet>
				<title>OTA Booking Detail</title>
			</Helmet>
			<HotelOtaBooking bookingId={Number(bookingId)} />
		</>
	)
}
